import React from "react";
import { Link, NavLink } from "react-router-dom";

const Footer = () => {
  const footerStyle = {
    background: "linear-gradient(#3E1F1B, #6A3E2F)",
    color: "#ffffff",
    padding: "30px",
    textAlign: "left",
    display: "flex",
    flexDirection: "column",
    borderTopLeftRadius: "20px",
    borderTopRightRadius: "20px",
    fontFamily: "Arial, sans-serif",
    height: "auto", // ✅ Fixes extra spacing
    width: "100%",
    position: "relative",
    marginTop: "auto", // ✅ Ensures footer sticks to bottom
  };

  const columnStyle = {
    flex: "1",
    minWidth: "200px",
    margin: "10px",
  };

  const titleStyle = {
    fontWeight: "bold",
    fontSize: "18px",
    marginBottom: "15px",
  };

  const linkListStyle = {
    listStyleType: "none",
    padding: "0",
    fontSize: "14px",
  };

  const linkStyle = {
    textDecoration: "none",
    color: "#ffffff",
    display: "block",
    margin: "8px 0",
    fontWeight: "500",
  };

  return (
    <footer style={footerStyle}>
      {/* Footer Content */}
      <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-between" }}>
        {/* Left Section */}
        <div style={columnStyle}>
          <h3 style={{ color: "rgb(247, 239, 122)", fontWeight: "bold", fontFamily: "Abel" }}>
            Vaira Maaligai
          </h3>
          <p>
            <a
              href="https://www.google.com/maps?q=No.31+Salem+main+road+Kallakurichi+Tamil+Nadu+606202"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#FFD700", textDecoration: "none" }}
            >
              📍 No.31, Salem Main Road, Kallakurichi, Tamil Nadu 606202, India.
            </a>
          </p>
          <p>📞 +91 9500422264 , 225764, 222264</p>
        </div>

        {/* Important Links Section */}
        <div style={columnStyle}>
          <h4 style={titleStyle}>Important Links</h4>
          <ul style={linkListStyle}>
            <li><Link to="/" style={linkStyle}>Home</Link></li>
            <li><Link to="/about" style={linkStyle}>About</Link></li>
            <li><Link to="/contact" style={linkStyle}>Contact Us</Link></li>
          </ul>
        </div>

        {/* Policy Links Section */}
        <div style={columnStyle}>
          <h4 style={titleStyle}>Policies & More</h4>
          <ul style={linkListStyle}>
            <li><Link to="/PrivacyPolicy" style={linkStyle}>Privacy Policy</Link></li>
            <li><Link to="/Terms_And_Conditions" style={linkStyle}>Terms & Conditions</Link></li>
            <li><Link to="/CancellationPolicy" style={linkStyle}>Cancellation Policy</Link></li>
            <li><Link to="/RefundPolicy" style={linkStyle}>Refund Policy</Link></li>
            <li><Link to="/about1" style={linkStyle}>About Us</Link></li>
            <li><Link to="/Login" style={linkStyle}>Admin Login</Link></li>
          </ul>
        </div>
      </div>



      {/* Copyright Section */}
      <div style={{ textAlign: "center", fontSize: "14px", borderTop: "1px solid #ffffff", paddingTop: "10px" }}>
        &copy; {new Date().getFullYear()}{" "}
        <a
          href="https://www.brightechsoftware.com/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#FFD700", textDecoration: "none" }}
        >
          Brightech Software Solution
        </a>
      </div>
      
    </footer>
  );
};

export default Footer;
